import React from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

// Sunum bileşeni: durum tutmaz, yalnızca props alır.
const CookieBanner = ({ onAccept, onReject }) => (
  <div className="cookie-banner" role="dialog" aria-modal="false" aria-label="Cookie consent">
    <div className="cookie-banner__content">
      <div className="cookie-banner__text">
        <h2 className="cookie-banner__title">We use cookies</h2>
        <p className="cookie-banner__description">
          We use necessary cookies to make our site work, and analytics cookies to understand
          how it is used. Read our <Link to="/cookie-policy">Cookie Policy</Link>.
        </p>
      </div>

      {/* Her iki buton da aynı boyut ve ağırlıkta olmalı: AB mevzuatı reddetmeyi
          kabul etmek kadar kolay hâle getirmeyi zorunlu kılıyor. */}
      <div className="cookie-banner__actions">
        <button type="button" className="cookie-banner__button" onClick={onReject}>
          Reject all
        </button>
        <button type="button" className="cookie-banner__button" onClick={onAccept}>
          Accept all
        </button>
      </div>
    </div>
  </div>
);

export default CookieBanner;
